import React, { useEffect, useState } from "react";
import { isBrowser, isMobile } from "react-device-detect";
import { Box, Typography, Grid, CircularProgress } from "@mui/material";
import { getCommentStatusApi } from "../../../api/predefine.js";
import dayjs from "dayjs";
import Popup from "../../../component/popup/Popup.js";
import CommentsList from "./CommentsList.js";
import MainTable from "../../../component/table/MainTable.js";
import SelectComponent from "../../../component/SelectComponent.js";

const CommentsDetailsPopup = ({ open, onClose, comments, onCommentResolved, isResolving, user, currentCommentID, ...props }) => {
  const [commentTableData, setCommentTableData] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [selectedCommentId, setSelectedCommentId] = useState([]);

  useEffect(() => {
    initCommentStatus();
  }, []);

  useEffect(() => {
    if (comments.length) {
      initCommentTableData();
    } else {
      setCommentTableData([]);
      setSelectedCommentId([]);
    }
  }, [comments, selectedStatus, currentCommentID]);

  const initCommentTableData = () => {
    setCommentTableData(
      comments
        .filter((c) => selectedStatus.includes(c.status))
        .map((c) => {
          return {
            id: c.commentId,
            projectCommentId: c.projectCommentId,
            status: (
              <img
                src={`assets/icons/${c.status === "Pending" ? "orangeclock" : "ok"}.svg`}
                alt={c.status}
                style={{ verticalAlign: "bottom", marginRight: "4px" }}
              />
            ),
            header: c.header,
            createDateTime: dayjs(c.createDateTime).format("DD/MM/YYYY"),
            createBy: c.createBy.name,
          };
        })
    );
    setSelectedCommentId([currentCommentID || comments[0].commentId]);
  };

  const initCommentStatus = async () => {
    const result = await getCommentStatusApi();
    setStatusOptions(
      result.data.map((d) => {
        return { label: d.label, value: d.label };
      })
    );
    setSelectedStatus(result.data.map((d) => d.label));
  };

  const commentTableHeaders = [
    { id: "status", label: "", align: "center" },
    { id: "id", label: "ID", align: "center" },
    { id: "header", label: "Comment Header", align: "left" },
    { id: "createDateTime", label: "Created Date", align: "left" },
    { id: "createBy", label: "Created by", align: "left" },
  ];

  return (
    <Popup
      open={open}
      onClose={onClose}
      title={props.detailsOnly ? "Comment Details" : "Comments and Files"}
      noModal={isMobile}
      isExpanded={isMobile}
      popupStyle={
        isBrowser
          ? {
              minWidth: 900,
            }
          : {}
      }
    >
      <Grid container spacing={1} sx={{ py: 2, px: isMobile ? 1.5 : 4 }}>
        {!props.detailsOnly && (
          <Grid item xs={isMobile ? 12 : 6}>
            <Box display="flex" gap={1} alignItems={"center"} height={35}>
              <Typography sx={{ fontSize: 11 }}>Select Comment</Typography>
              <SelectComponent
                options={statusOptions}
                value={selectedStatus}
                isMultiSelect
                onChange={(value) => {
                  setSelectedStatus(value);
                }}
                selectStyle={{ width: 200 }}
              ></SelectComponent>
            </Box>
            <MainTable
              sx={{ maxHeight: 500, height: isMobile ? "auto" : 500 }}
              columns={commentTableHeaders}
              rows={commentTableData}
              headerStyles={{
                default: { backgroundColor: "#F1F1F1" },
              }}
              columnWidths={{
                ID: "50px",
                DateTime: "160px",
                Reporter: "175px",
              }}
              selectable="single"
              rowClickColor={"#EBFFFE"}
              selected={selectedCommentId}
              setSelected={setSelectedCommentId}
            />
          </Grid>
        )}
        <Grid item xs={isMobile ? 12 : 6}>
          {!props.detailsOnly && (
            <Box display="flex" alignItems={"center"} height={35}>
              <Typography sx={{ fontSize: 11 }}>View Comment Detail</Typography>
            </Box>
          )}
          <Box
            sx={{
              flex: 1,
              border: "1px solid #D0D5DE",
              borderRadius: "5px",
              maxHeight: 500,
              height: isMobile ? "auto" : 500,
              overflow: "auto",
              px: 3,
              pb: 3,
              pt: 2,
            }}
          >
            {isResolving ? (
              <CircularProgress />
            ) : (
              comments
                .filter((c) => selectedCommentId.includes(c.commentId))
                .map((comment) => <CommentsList key={comment.commentId} comment={comment} onCommentResolved={onCommentResolved} user={user} />)
            )}
          </Box>
        </Grid>
      </Grid>
      {/* <Box sx={{ py: 2, px: 4, display: "flex" }} gap={1}>
        <Box sx={{ flex: 1, border: "1px solid #D0D5DE", borderRadius: "5px", maxHeight: "600px", overflow: "auto", px: 3, py: 1 }}>
          <Typography>
            <span style={{ fontWeight: 700 }}>Files Uploaded</span>
            <span> (click to download) </span>
          </Typography>
          <Divider variant="fullWidth" sx={{ mt: 1, mb: 2 }} />
          <Grid container>
            {allCommentFiles?.map((file, index) => (
              <Grid item xs={4} key={index}>
                <Box sx={{ pb: 2, textAlign: "center", cursor: "pointer" }} onClick={() => downloadFile(file)}>
                  <img src={`${getFileTypeIcon(file.format)}`} alt="file"></img>
                  <Typography variant="body1">{file.filename}</Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box> */}
    </Popup>
  );
};

export default CommentsDetailsPopup;
